import React, { useRef, useEffect } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { getCurrentUser, cleanupSupportChat } from '../../utils/helpers';

const SupportChat = () => {
  const elRef = useRef();
  const currentUser = getCurrentUser();


  useEffect(() => {
    try {
      window?.Tawk_API?.showWidget();

      if (window?.Tawk_API?.setAttributes) {
        window.Tawk_API.setAttributes({
          name: currentUser?.fullName,
          email: currentUser?.email,
        }, function (error) {
          // do something if error
        });
      }
    } catch (error) {
      // ...
    }

    return () => {
      // Cleanup Tawk.to chat when component unmounts
      // cleanupSupportChat();
    };
  }, []);


  const onLoad = () => {
    try {
      if (!elRef?.current) return;

      elRef.current.setAttributes({
        name: currentUser?.fullName,
        email: currentUser?.email,
      }, function (error) {
        // do something if error
      });

    } catch (error) {
      console.error('Error Tawk.to:', error);
    };
  };

  const customStyle = {
    visibility: {
      desktop: {
        xOffset: 10,
        yOffset: 0,
        position: 'br'
      },

      mobile: {
        xOffset: 10,
        yOffset: 105,
        position: 'br'
      }
    }
  };

  return (
    <TawkMessengerReact
      propertyId="682dd7ba98a1b819123fbc7d"
      widgetId="1irph5clg"
      onLoad={onLoad}
      ref={elRef}
      customStyle={customStyle}
    />
  )
}

export default SupportChat;